import request from 'utils/request'
import { MCBLS030InitRequest } from 'types/MCBLS030/MCBLS030InitRequest'

export const initRequest = (apidata: MCBLS030InitRequest) =>
    request({
        url: '/MCBLS030/init',
        method: 'post',
        data: apidata,
    })